import React from 'react';
import {
  ColorPalette,
  WidgetProps,
} from './types';
import styles from './styles.module.scss';
import classNames from 'classnames'
import { images } from '../../../../assets/image';

const HomePointsWidget: React.FC<WidgetProps> = (props: WidgetProps) => {
  const {
    widgetParams,
    defaultPaddings,
  } = props;



  return (
    <div
      className={classNames([styles.TitleCard])}
      style={defaultPaddings}
    >
      <h4>{props.widgetParams.title}</h4>
      <div>
        <span>30</span>
        <span>{props.widgetParams.pointsSpan}</span>
      </div>
    </div>
  );
};

export default HomePointsWidget;
